import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { AGENT_COMPOSER_INPUT_ID } from '../components/agentChat/AgentChatComposer';
import isElectron from '../utils/isElectron';

export const isAppleKeyboard = (): boolean =>
  /Mac|iPhone|iPad/.test(navigator.userAgent);

/** Modifier glyph for shortcut hints, so the labels match the real keys. */
export const shortcutModifierSymbol = (): string =>
  isAppleKeyboard() ? '⌘' : 'Ctrl';

/**
 * Dashboard-level keyboard shortcuts: the modifier plus K jumps to the agent
 * composer, plus N starts a new crate.
 */
export const useDashboardShortcuts = (): void => {
  const history = useHistory();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.altKey || !(event.metaKey || event.ctrlKey)) return;

      const key = event.key.toLowerCase();

      if (key === 'k' && isElectron()) {
        const composer = document.getElementById(
          AGENT_COMPOSER_INPUT_ID,
        ) as HTMLTextAreaElement | null;
        if (!composer) return;
        event.preventDefault();
        composer.focus();
        return;
      }

      if (key === 'n') {
        event.preventDefault();
        history.push('/my-crates');
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [history]);
};

export default useDashboardShortcuts;
